import React, { useRef, useState } from 'react';
import { connect } from 'react-redux'

import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'

import { createProject } from '../../../../store/actions/projectActions'
import './CreateProject.css'


const CreateProject = (props) => {

    const blankProject = { 
        client: '', address: '',
        city: '', addressLink: '', workstations: '',
        type: '', day: '', startTime: '', endTime: '',
        bartStation: '', bartDistance: '',
        notes: '',
        contacts: {
            primary:   { nameTitle: "", phone: "" },
            alternate: { nameTitle: "", phone: "" },
            onsite:    { nameTitle: "", phone: "" },
        }
    };

    const [projectState, setProjectState] = useState([
        {...blankProject}
    ]);
    const [showContacts, setShowContacts] = useState([false]);

    const addProject = () => {
        setProjectState([...projectState, {
            client: projectState[0].client,
            address: projectState[0].address, city: projectState[0].city,
            addressLink: projectState[0].addressLink, workstations: projectState[0].workstations,
            type: '', day: '', startTime: '', endTime: '',
            bartStation: projectState[0].bartStation, bartDistance: projectState[0].bartDistance,
            notes: projectState[0].notes,
            contacts: {
                primary:   { ...projectState[0].contacts.primary },
                alternate: { ...projectState[0].contacts.alternate },
                onsite:    { ...projectState[0].contacts.onsite },
            }
        }]);

        setShowContacts(prev => [...prev, prev[0] || false]);
    };

    const handleProjectChange = (e) => {
        const updatedProjects = [...projectState];
        updatedProjects[e.target.dataset.index][e.target.id] =
            e.target.value;
        setProjectState(updatedProjects)
    }

    const handleContactChange = (e) => {
        const updatedProjects = [...projectState];
        const idx = Number(e.target.dataset.index);
        const contactType = e.target.dataset.contactType; // "primary" | "alternate" | "onsite"
        const field = e.target.dataset.field; // "nameTitle" | "phone"

        updatedProjects[idx].contacts = {
            ...updatedProjects[idx].contacts,
            [contactType]: {
                ...updatedProjects[idx].contacts[contactType],
                [field]: e.target.value,
            }
        };

        setProjectState(updatedProjects);
    };

    //const [validated, setValidated] = useState(false);
    const formRef = useRef(null);

    const handleSubmit = (event) => {
        // Handle specific changes before sending to Firebase
        projectState.forEach(project => {
            event.preventDefault();
            project.startTime = project.day + ' ' + project.startTime
            project.endTime = project.day + ' ' + project.endTime
            delete project.day

            if (project.type === "Post-move") {
                project.workstations = 0
            }
        })
        props.createProject(projectState)
        handleFormReset()
    }

    const handleFormReset = () => {
        Array.from(document.querySelectorAll("input, select, textarea")).forEach(
            input => (input.value = "")
          );

        setProjectState([{...blankProject}]);
        setShowContacts([false]);
    }

return (
  <Card body>
    <Form ref={formRef} onSubmit={handleSubmit}>
      <h4>Create a New Project</h4>

      {projectState.map((val, index) => {
        return (
          <div key={index}>
            <Form.Row>
              <Form.Group className="FormEntries" as={Col} controlId="type">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  as="select"
                  data-index={index}
                  onChange={handleProjectChange}
                >
                  <option></option>
                  <option>Disconnect</option>
                  <option>Reconnect</option>
                  <option>Shuffle</option>
                  <option>Post-move</option>
                  <option>Server</option>
                  <option>Support</option>
                  {/* Don't forget to change EditProject */}
                </Form.Control>
              </Form.Group>

              <Form.Group className="FormEntries" as={Col} controlId="workstations">
                {projectState[index].type !== "Server" && (
                  <Form.Label>Workstations</Form.Label>
                )}

                {projectState[index].type === "Server" && (
                  <Form.Label>Servers</Form.Label>
                )}

                <Form.Control
                  type="number"
                  data-index={index}
                  placeholder={projectState[0].workstations || "Enter a number"}
                  onChange={handleProjectChange}
                />
              </Form.Group>
            </Form.Row>

            {(index === 0 || projectState[index].type) && (
              <div>
                <Form.Row>
                  <Form.Group className="FormEntries" as={Col} controlId="client">
                    <Form.Label>Client</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].client || "Enter client name"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group className="FormEntries" as={Col} controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].address || "Enter address"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>

                  <Form.Group className="FormEntries" as={Col} controlId="city">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].city || "Enter city"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>

                  <Form.Group className="FormEntries" as={Col} controlId="addressLink">
                    <Form.Label>Google Maps Link</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].addressLink || "Enter link"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group className="FormEntries" as={Col} controlId="day">
                    <Form.Label>Date</Form.Label>
                    <Form.Control
                      type="date"
                      data-index={index}
                      placeholder="Enter a day"
                      onChange={handleProjectChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="FormEntries" as={Col} controlId="startTime">
                    <Form.Label>Start Time</Form.Label>
                    <Form.Control
                      type="time"
                      data-index={index}
                      placeholder="Enter the start time"
                      onChange={handleProjectChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="FormEntries" as={Col} controlId="endTime">
                    <Form.Label>End Time</Form.Label>
                    <Form.Control
                      type="time"
                      data-index={index}
                      placeholder="Enter the end time"
                      onChange={handleProjectChange}
                      required
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row>
                  <Form.Group className="FormEntries" as={Col} controlId="bartStation">
                    <Form.Label>Nearest BART Station</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].bartStation || "Enter the nearest BART Station"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>

                  <Form.Group className="FormEntries" as={Col} controlId="bartDistance">
                    <Form.Label>Distance to BART</Form.Label>
                    <Form.Control
                      type="text"
                      data-index={index}
                      placeholder={projectState[0].bartDistance || "Enter the distance to BART"}
                      onChange={handleProjectChange}
                    />
                  </Form.Group>
                </Form.Row>

                <Form.Row className="align-items-start">
                  {/* Notes */}
                  <Col xs={6}>
                    <Form.Group controlId="notes">
                      <Form.Label>Notes</Form.Label>
                      <Form.Control
                        as="textarea"
                        data-index={index}
                        type="text"
                        placeholder="Enter any additional notes"
                        onChange={handleProjectChange}
                      />
                    </Form.Group>
                  </Col>

                  {/* Add Contacts Button */}
                  <Col
                    xs={6}
                    className="FormEntries d-flex flex-column justify-content-start"
                  >
                    <div style={{ height: "32px" }} />
                    <Button
                      className="contacts-toggle-btn"
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => {
                        const updated = [...showContacts];
                        updated[index] = !updated[index];
                        setShowContacts(updated);
                      }}
                    >
                      {showContacts[index] ? "Hide Contacts" : "Add Contacts"}
                    </Button>
                  </Col>
                </Form.Row>


                {showContacts[index] && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                      Contacts{" "}
                      <span style={{ fontSize: 11, opacity: 0.65, fontWeight: 400 }}>
                        (visible to supervisors/leads only)
                      </span>
                    </div>

                    {/* Primary */}
                    <Form.Row>
                      <Form.Group className="FormEntries" as={Col} controlId={`primaryNameTitle-${index}`}>
                        <Form.Label>Primary (Name/Title)</Form.Label>
                        <Form.Control
                          type="text"
                          data-index={index}
                          data-contact-type="primary"
                          data-field="nameTitle"
                          placeholder="Jane Doe / Facilities"
                          onChange={handleContactChange}
                        />
                      </Form.Group>

                      <Form.Group className="FormEntries" as={Col} controlId={`primaryPhone-${index}`}>
                        <Form.Label>Primary Phone</Form.Label>
                        <Form.Control
                          type="tel"
                          data-index={index}
                          data-contact-type="primary"
                          data-field="phone"
                          placeholder="(555) 555-5555"
                          onChange={handleContactChange}
                        />
                      </Form.Group>
                    </Form.Row>

                    {/* Alternate */}
                    <Form.Row>
                      <Form.Group className="FormEntries" as={Col} controlId={`alternateNameTitle-${index}`}>
                        <Form.Label>Alternate (Name/Title)</Form.Label>
                        <Form.Control
                          type="text"
                          data-index={index}
                          data-contact-type="alternate"
                          data-field="nameTitle"
                          placeholder="John Smith / IT"
                          onChange={handleContactChange}
                        />
                      </Form.Group>

                      <Form.Group className="FormEntries" as={Col} controlId={`alternatePhone-${index}`}>
                        <Form.Label>Alternate Phone</Form.Label>
                        <Form.Control
                          type="tel"
                          data-index={index}
                          data-contact-type="alternate"
                          data-field="phone"
                          placeholder="(555) 555-5555"
                          onChange={handleContactChange}
                        />
                      </Form.Group>
                    </Form.Row>

                    {/* Onsite */}
                    <Form.Row>
                      <Form.Group className="FormEntries" as={Col} controlId={`onsiteNameTitle-${index}`}>
                        <Form.Label>Onsite (Name/Title)</Form.Label>
                        <Form.Control
                          type="text"
                          data-index={index}
                          data-contact-type="onsite"
                          data-field="nameTitle"
                          placeholder="Reception / Front Desk"
                          onChange={handleContactChange}
                        />
                      </Form.Group>

                      <Form.Group className="FormEntries" as={Col} controlId={`onsitePhone-${index}`}>
                        <Form.Label>Onsite Phone</Form.Label>
                        <Form.Control
                          type="tel"
                          data-index={index}
                          data-contact-type="onsite"
                          data-field="phone"
                          placeholder="(555) 555-5555"
                          onChange={handleContactChange}
                        />
                      </Form.Group>
                    </Form.Row>
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}

      <Button variant="primary" onClick={addProject}>
        Add Project
      </Button>{" "}
      <Button type="Submit" variant="success">
        Submit
      </Button>
    </Form>
  </Card>
);

};

const mapDispatchToProps = dispatch => {
    return {
      createProject: (projectArray) => dispatch(createProject(projectArray)),
    }
  
}

export default connect(null, mapDispatchToProps)(CreateProject);
